import { render, staticRenderFns } from "./PreviousTasksDialog.vue?vue&type=template&id=fa870ee0&scoped=true"
import script from "./PreviousTasksDialog.vue?vue&type=script&lang=js"
export * from "./PreviousTasksDialog.vue?vue&type=script&lang=js"
import style0 from "./PreviousTasksDialog.vue?vue&type=style&index=0&id=fa870ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa870ee0",
  null
  
)

export default component.exports